<template>
  <div class="mt-3">
    <v-row>

      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            BLs et montants par distributeur – Tableau
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="table"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <v-data-table
                class="rounded-lg table-border"
                :headers="headers"
                :items="distributeurs"
                :items-per-page="5"
                :footer-props="{ itemsPerPageText: 'Éléments par page' }"
            >
              <template v-slot:item.distributor="{ item }">
                <span class="text-no-wrap">{{ item.distributor }}</span>
              </template>
              <template v-slot:item.total_amount="{ item }">
                <span class="text-no-wrap font-weight-bold gifty-text">
                  {{ CurrencyFormatting(item.total_amount) }} DZD
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>


      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            BLs et montants par distributeur – Graphe
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="image,article"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <apexchart
                type="bar"
                height="300"
                :options="chartOptions"
                :series="chartSeries"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['boosting_method_id'],
  data() {
    return {
      fullscreen: false,
      isLoading: false,
      headers: [
        {text: 'Distributeur', value: 'distributor'},
        {text: 'Nombre de BLs', value: 'number_of_bls'},
        {text: 'Montant total', value: 'total_amount'}
      ],
      distributeurs: [],
      chartOptions: {
        colors: ["#8E24AA"],
        chart: {
          toolbar: {show: false}
        },
        xaxis: {
          categories: [],
          title: {text: 'Distributeurs'}
        },
        yaxis: {
          title: {text: 'Montant (DZD)'}
        },
        dataLabels: {enabled: true},
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false
          }
        }
      },
      chartSeries: []
    }
  },
  methods: {
    getDistributeurs() {
      this.isLoading = true
      if (!this.boosting_method_id) return;
      HTTP.get('/v1/boosting-methods/dashboard/distributeurs', {
        params: {boosting_method_id: this.boosting_method_id}
      }).then(res => {
        this.isLoading = false
        this.distributeurs = res.data.data

        // --- Update chart ---
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {categories: this.distributeurs.map(d => d.distributor)}
        }
        this.chartSeries = [
          {
            name: "Montant total (DZD)",
            data: this.distributeurs.map(d => d.total_amount)
          }
        ]
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    CurrencyFormatting(value) {
      return new Intl.NumberFormat('fr-FR').format(value)
    }
  },
  created() {
    this.getDistributeurs()
  },
  watch: {
    boosting_method_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDistributeurs();
      }
    }
  }
}
</script>
